import axios from 'axios';
import { useEffect, useState } from 'react';
import { NotificationManager } from 'react-notifications';
import { Link } from 'react-router-dom';
import './style.scss';
const FooterForm = () => {

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [fullName, setFullName] = useState('');
    // const [lastName, setLastName] = useState('');
    const [emailAddress, setEmailAddress] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [selectedCaseType, setSelectedCaseType] = useState('');
    const [employerName, setEmployerName] = useState('');
    const [comment, setComment] = useState('');
    const [isFetching, setIsFetching] = useState(false);
    const [isDisabled, setIsDisabled] = useState(false);
    const caseTypes = [
        "Noncompete Agreements",
        "Business Litigation / Disputes",
        "Agreement Drafting / Review",
        "Employer Defense",
        "Other",
    ];
    useEffect(() => {
        document.getElementById('phone_number').addEventListener('input', function (e) {
            var x = e.target.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
            setPhoneNumber(!x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : ''));
        });

        window.addEventListener('click', handleClickOutside);
        return () => {
        window.removeEventListener('click', handleClickOutside);
        }
    }, []);

    const handleClickOutside = (event) => {
        if (document.querySelector('.custom_case_type')) {
            if (!document.querySelector('.custom_case_type').contains(event.target)) {
                document.querySelector('.selected_case_type').classList.remove('active');
            }
        }
    }
    

    const onClickCaseType = (type) => {
        setSelectedCaseType(type);
        document.querySelector('.selected_case_type').classList.remove('active');
    }

    const onSubmitForm = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        try {
            await axios.post(
                '/wp-json/gf/v2/forms/4/submissions', // Replace {form_id} with your actual Gravity Form ID
                {
                    'input_1': fullName,
                    'input_2': emailAddress,
                    'input_3': phoneNumber,
                    'input_10': selectedCaseType,
                    'input_7': employerName,
                    'input_4': comment,
                    'input_6': window.location.href
                },
                {
                  headers: {
                    'Content-Type': 'application/json',
                  },
                }
            );

            NotificationManager.success('Form has been submitted successfully!', 'Success!');
            setFullName('');
            setSelectedCaseType('');
            setEmployerName('');
            setEmailAddress('');
            setPhoneNumber('');
            setComment('');
        } catch (err) {
            console.log(err);
        } finally {
            setIsSubmitting(false);
        }
        return false;
    }

    return <div className='footer-form-wrapper'>
        <div id="form-heading">
            <span className='form-title'>
                Book Your Consultation
            </span>
            <span className='form-details'>
                <svg width="11" height="14" viewBox="0 0 11 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.75 13.75C1.40625 13.75 1.11198 13.6276 0.867188 13.3828C0.622396 13.138 0.5 12.8438 0.5 12.5V6.25C0.5 5.90625 0.622396 5.61198 0.867188 5.36719C1.11198 5.1224 1.40625 5 1.75 5H2.375V3.75C2.375 2.88542 2.67969 2.14844 3.28906 1.53906C3.89844 0.929687 4.63542 0.625 5.5 0.625C6.36458 0.625 7.10156 0.929687 7.71094 1.53906C8.32031 2.14844 8.625 2.88542 8.625 3.75V5H9.25C9.59375 5 9.88802 5.1224 10.1328 5.36719C10.3776 5.61198 10.5 5.90625 10.5 6.25V12.5C10.5 12.8438 10.3776 13.138 10.1328 13.3828C9.88802 13.6276 9.59375 13.75 9.25 13.75H1.75ZM1.75 12.5H9.25V6.25H1.75V12.5ZM5.5 10.625C5.84375 10.625 6.13802 10.5026 6.38281 10.2578C6.6276 10.013 6.75 9.71875 6.75 9.375C6.75 9.03125 6.6276 8.73698 6.38281 8.49219C6.13802 8.2474 5.84375 8.125 5.5 8.125C5.15625 8.125 4.86198 8.2474 4.61719 8.49219C4.3724 8.73698 4.25 9.03125 4.25 9.375C4.25 9.71875 4.3724 10.013 4.61719 10.2578C4.86198 10.5026 5.15625 10.625 5.5 10.625ZM3.625 5H7.375V3.75C7.375 3.22917 7.19271 2.78646 6.82812 2.42188C6.46354 2.05729 6.02083 1.875 5.5 1.875C4.97917 1.875 4.53646 2.05729 4.17188 2.42188C3.80729 2.78646 3.625 3.22917 3.625 3.75V5Z" fill="#037C8E"/>
                </svg>
                Your information is securely encrypted.
            </span>
        </div>
        <form id="contact-form" onSubmit={onSubmitForm}>
            <div className='form-field required'>
                <input
                    type="text" 
                    name="full_name" 
                    id="full_name" 
                    placeholder="First & Last Name"
                    required
                    value={fullName} 
                    onChange={(e) => {
                        setFullName(e.target.value);
                    }}
                />
            </div>
            <div className='form-field required'>
                <input
                    type="email" 
                    name="email_address" 
                    id="email_address" 
                    placeholder="Email Address"
                    required
                    value={emailAddress}
                    onChange={(e) => {
                        setEmailAddress(e.target.value)
                    }}
                />
            </div>
            <div className='form-field required'>
                <input
                    type="tel"
                    name="phone_number"
                    id="phone_number"
                    placeholder="Phone Number"
                    required
                    value={phoneNumber}
                    onChange={(e) => {
                        setPhoneNumber(e.target.value)
                    }}
                />
            </div>
            <div className='custom_case_type'>
                <div className={`selected_case_type ${selectedCaseType?.length < 1 ? 'none' : ''}`} onClick={(e) => {
                    if (e.currentTarget.classList.contains('active')) {
                        e.currentTarget.classList.remove('active');
                    } else {
                        e.currentTarget.classList.add('active');
                    }
                }}>
                    <input type="text" required value={selectedCaseType} />
                    <span className='value'>
                        {selectedCaseType?.length < 1 ? 'CASE TYPE' : selectedCaseType}
                    </span>
                    <span className='arrow'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <mask id="mask0_1755_47" style={{maskType: 'alpha'}} maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
                                <rect width="20" height="20" fill="#D9D9D9"/>
                            </mask>
                            <g mask="url(#mask0_1755_47)">
                                <path d="M10 12.8333L5 7.83333L6.16667 6.66667L10 10.5L13.8333 6.66667L15 7.83333L10 12.8333Z" fill="#001926" fillOpacity="0.75"/>
                            </g>
                        </svg>
                    </span>
                </div>
                <div className='case-type-list'>
                    <ul>
                        {
                            caseTypes?.map((it, index) => <li key={index} onClick={() => {
                                onClickCaseType(it)
                            }}>{it}</li>)
                        }
                    </ul>
                </div>
            </div>

            {selectedCaseType === caseTypes[0] && <input 
                type="text" 
                name="name_of_employeer" 
                id="name_of_employeer" 
                placeholder='Name of employer'
                value={employerName}
                onChange={(e) => {
                    setEmployerName(e.target.value);
                }}
            />}
            <textarea
                name="message"
                placeholder="Tell Us about your case" 
                value={comment}
                required
                onChange={(e) => {
                    setComment(e.target.value)
                }}
            />
            <div className='check-box'>
                <input type="checkbox" name="agree_term_conditions" id="agree_term_conditions" onChange={(e) => {
                    setIsDisabled(e.target.checked)
                }} />
                <label htmlFor="agree_term_conditions">
                    <span>
                        I agree to the <Link to={"/terms-conditions/"} target="_blank">terms and conditions</Link>.
                    </span>
                </label>
            </div>
            <div className="footer-form">
                <button type="submit" disabled={isSubmitting || !isDisabled}>
                    {isSubmitting ? 'Submitting...' : 'Submit'}
                </button>
            </div>
        </form>
    </div>
}

export default FooterForm;